/* ROF Newsletter Popup — behavior */
(function () {
  if (window.__rofPopupInit) return;
  window.__rofPopupInit = true;

  var STORAGE_KEY     = 'rof_newsletter_popup_v1';
  var DISMISS_DAYS    = 7;
  var SUBSCRIBED_DAYS = 60;

  function readState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeState(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
    catch (e) {}
  }
  function shouldShow() {
    var state = readState();
    var now = Date.now();
    if (state.subscribedAt && (now - state.subscribedAt) < SUBSCRIBED_DAYS * 86400000) return false;
    if (state.dismissedAt && (now - state.dismissedAt) < DISMISS_DAYS * 86400000) return false;
    return true;
  }
  function markDismissed() {
    var state = readState();
    state.dismissedAt = Date.now();
    writeState(state);
  }
  function markSubscribed() {
    var state = readState();
    state.subscribedAt = Date.now();
    state.dismissedAt = Date.now();
    writeState(state);
  }

  function init() {
    var popup = document.getElementById('rof-newsletter-popup');
    if (!popup) return;
    if (popup.getAttribute('data-skip') === 'true') return;

    var delaySeconds = parseInt(popup.getAttribute('data-delay'), 10) || 5;
    var hasOpened = false;
    var hasSubmitted = false;
    var openTimer = null;
    var scrollTriggered = false;

    var form         = popup.querySelector('.rof-popup__form');
    var submitBtn    = popup.querySelector('.rof-popup__submit');
    var emailInput   = popup.querySelector('.rof-popup__input');
    var defaultState = popup.querySelector('[data-rof-state="default"]');
    var successState = popup.querySelector('[data-rof-state="success"]');

    // Disable native form submission completely — prevents any page-reload race
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
    }
    if (submitBtn) {
      // Force the submit button to be type="button" so it can never trigger form POST
      submitBtn.setAttribute('type', 'button');
    }

    function openPopup() {
      if (hasOpened) return;
      hasOpened = true;
      popup.hidden = false;
      popup.setAttribute('data-open', 'true');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      cleanupTriggers();
      if (emailInput) setTimeout(function () { emailInput.focus(); }, 100);
    }

    function closePopup(opts) {
      opts = opts || {};
      popup.setAttribute('data-open', 'false');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { popup.hidden = true; }, 200);
      if (!opts.skipDismiss && !hasSubmitted) markDismissed();
    }

    // Close handlers — only enabled BEFORE submission
    var closeBtns = popup.querySelectorAll('[data-rof-close]');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.getAttribute('data-open') === 'true') {
        closePopup();
      }
    });

    // Copy code handler
    var copyBtn = popup.querySelector('[data-rof-copy]');
    var codeEl  = popup.querySelector('[data-rof-code]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        var fallback = function () {
          var t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(fallback);
        } else {
          fallback();
        }
        copyBtn.setAttribute('data-copied', 'true');
        copyBtn.textContent = 'Copied!';
        setTimeout(function () {
          copyBtn.removeAttribute('data-copied');
          copyBtn.textContent = 'Copy';
        }, 2500);
      });
    }

    function selectCodeText() {
      if (!codeEl) return;
      try {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) {}
    }

    function submitForm() {
      if (hasSubmitted) return;
      if (!form || !emailInput) return;

      // Validate email
      var email = (emailInput.value || '').trim();
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(email)) {
        emailInput.focus();
        emailInput.style.borderColor = '#8b2c1a';
        return;
      }

      hasSubmitted = true;
      var textEl = popup.querySelector('.rof-popup__submit-text');
      var loadEl = popup.querySelector('.rof-popup__submit-loading');
      if (submitBtn) submitBtn.disabled = true;
      if (textEl) textEl.hidden = true;
      if (loadEl) loadEl.hidden = false;

      var formData = new FormData(form);
      // Ensure required Shopify form fields are present
      if (!formData.get('form_type')) formData.append('form_type', 'customer');
      if (!formData.get('utf8')) formData.append('utf8', '✓');

      fetch('/contact#contact_form', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      }).then(function (res) {
        return res.text().catch(function () { return ''; });
      }).then(function () {
        markSubscribed();
        if (defaultState) defaultState.hidden = true;
        if (successState) successState.hidden = false;
        // Auto-select the code so user can immediately Cmd/Ctrl+C
        setTimeout(selectCodeText, 150);
        // Fire GTM event
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'newsletter_signup',
            signup_location: 'homepage_popup',
            signup_offer: '5pct_welcome'
          });
        }
      }).catch(function () {
        hasSubmitted = false;
        if (submitBtn) submitBtn.disabled = false;
        if (textEl) textEl.hidden = false;
        if (loadEl) loadEl.hidden = true;
        alert('Something went wrong. Please try again.');
      });
    }

    // Submit via button click (NOT form submit) — bulletproof against native submission
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitForm();
      });
    }
    // Also support Enter key on email input
    if (emailInput) {
      emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitForm();
        }
      });
    }

    function cleanupTriggers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      document.removeEventListener('mouseout', exitIntent);
      window.removeEventListener('scroll', scrollTrigger);
    }
    function exitIntent(e) {
      if (e.clientY <= 0 && !e.relatedTarget) openPopup();
    }
    function scrollTrigger() {
      if (scrollTriggered) return;
      var scrolled = window.scrollY + window.innerHeight;
      var threshold = document.body.scrollHeight * 0.4;
      if (scrolled >= threshold) {
        scrollTriggered = true;
        openPopup();
      }
    }

    if (!shouldShow()) return;

    openTimer = setTimeout(openPopup, delaySeconds * 1000);
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('mouseout', exitIntent);
    }
    window.addEventListener('scroll', scrollTrigger, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();